<template>
  <Authenticated>
    <CogsNav />
    <div class="products-container">
      <section class="prod-section">
        <div class="content-wrapper">
          <div class="cogs-prods">
            <div class="form-container">
              <h2>Product</h2>
              <form @submit.prevent.stop="">
                <label for="name">Product Name:</label>
                <input type="text" name="name" v-model="currProduct.value.escaped" />

                <label for="price">Price ($):</label>
                <div class="gst">
                  <input type="number" step="any" name="price" id="price" v-model="productPrice" />
                  <div class="gst-radio">
                    <p>GST</p>
                    <label for="gst-incl">Incl:</label>
                    <input type="radio" name="GST" :value="true" id="gst-incl" v-model="currProduct.value.productGSTInclusive" />
                  </div>
                  <div class="gst-radio">
                    <label for="gst-excl">Excl:</label>
                    <input type="radio" name="GST" :value="false" id="gst-excl" v-model="currProduct.value.productGSTInclusive" />
                  </div>
                </div>

                <label for="uom">UOM (unit of measure):</label>
                <input list="uoms" name="uom" v-model="unitOfMeasure" />
                <datalist id="uoms">
                  <option v-for="unit in cogsUOM" v-bind:key="unit.key">{{ unit.key }}</option>
                </datalist>

                <label for="supplier">Supplier:</label>
                <input list="suppliers" name="supplier" v-model="currProduct.value.name" />
                <datalist id="suppliers">
                  <option v-for="supplier in cogsSuppliers" v-bind:key="supplier.key">{{ supplier.key }}</option>
                </datalist>
              </form>
              <div class="sub-btns">
                <button @click.stop.prevent="deleteProduct" class="danger" :disabled="!productRemovable" :class="{ 'btn-disabled': !productRemovable }">Remove Product</button>
                <button @click.stop.prevent="clearForm">Reset Form</button>
                <button class="action-colour" v-if="!altered" @click="addNewProduct">Add Product</button>
                <button class="action-colour" v-if="altered" @click="saveNewProduct">Save Product</button>
              </div>
            </div>

            <div v-if="productClicked" class="supplier-info">
              <h3>
                More Products:
                <sub>{{ currProduct.value.name }} has {{ supplierProducts.length }} other products</sub>
              </h3>
              <div class="supplier-prods">
                <button v-for="prod in supplierProducts" :key="prod" @click="loadProduct(prod)" class="prod-from-supplier" :title="prod.value.escaped">
                  {{ prod.value.escaped }}
                </button>
              </div>
            </div>
          </div>
          <div class="prod-list">
            <div class="search-container">
              <h2 v-if="foundProducts.length == 1">{{ foundProducts.length }} result</h2>
              <h2 v-else-if="foundProducts.length > 1">{{ foundProducts.length }} results</h2>
              <h2 v-else>All Products</h2>
              <input type="search" placeholder="Search Product..." v-model="searchQuery" />
              <ul v-if="foundProducts.length !== 0" class="found-prod">
                <li v-for="product in foundProducts" :key="product.key">
                  <a href="#" @click.stop.prevent="loadProduct(product)" class="prod-in-list">{{ product.value.escaped }}</a>
                </li>
              </ul>
              <ul v-if="foundProducts.length == 0" class="found-in">
                <li v-for="(product, idx) in cogsProducts" v-bind:key="product.key">
                  <a href="#" @click.prevent.stop="loadProduct(product)" class="prod-in-list">{{ product.key }}</a>
                  <div v-if="findRecipeByProductID(product.id).length == 0" class="delete-indicator">
                    <small>Not found in recipes</small>
                  </div>
                  <div v-else class="recipe-usage">
                    <div class="recipe-toggle" @click="handleExpand(idx)">
                      <small>
                        Found in recipes
                        <span><font-awesome-icon icon="chevron-right" :id="`${idx}-chevron`" /></span>
                      </small>
                      <div :id="idx" class="hide">
                        <p v-for="rec in findRecipeByProductID(product.id)" :key="rec.id">{{ rec.value.escaped }}</p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated";
import { cogsMixin } from "./shared/cogsMixin";
import CogsNav from "./shared/CogsNav.vue";

export default {
  name: "COGSProducts",
  components: { Authenticated, CogsNav },
  mixins: [cogsMixin],
  data() {
    return {
      altered: false,
      productPrice: "",
      unitOfMeasure: "",
      searchQuery: "",
      foundProducts: [],
      expanded: false,
      supplierProducts: [],
      productClicked: false,
      productRemovable: true,
      product: {
        value: {
          name: "",
          escaped: "",
          price_per_uom: "",
          productGSTInclusive: null,
          type: "supplier",
        },
      },
      currProduct: {
        value: {
          name: "",
          escaped: "",
          price_per_uom: "",
          type: "supplier",
          productGSTInclusive: null,
        },
      },
    };
  },
  computed: {
    currProductPrice() {
      return this.currProduct.value.price_per_uom.split(" ")[0];
    },
    currProductUOM() {
      return this.currProduct.value.price_per_uom.split(" ").slice(-1)[0];
    },
  },
  methods: {
    handleExpand(idx) {
      document.getElementById(`${idx}-chevron`).classList.toggle("expanded");
      let element = document.getElementById(idx);
      element.classList.toggle("recipe-list");
      element.classList.toggle("hide");
    },

    loadProduct(product) {
      const foundInRecipes = this.findRecipeByProductID(product.id);
      this.productRemovable = foundInRecipes.length === 0;
      this.currProduct = product;
      this.unitOfMeasure = this.currProductUOM;
      this.productPrice = this.currProductPrice;
      this.altered = true;
      this.productClicked = true;
      this.collectSupplierInfo(product.value.name);
    },

    async collectSupplierInfo(supplierName) {
      this.supplierProducts = await this.searchSupplierProducts(supplierName);
    },

    async addNewProduct() {
      this.currProduct.value.price_per_uom = this.productPrice + " per " + this.unitOfMeasure;
      const success = await this.saveCOGSDocument(this.currProduct);
      if (success) {
        this.currProduct = { ...this.product };
        this.unitOfMeasure = "";
        this.productPrice = "";
        this.altered = false;
        this.clearSearchQueries();
      }
    },

    async saveNewProduct() {
      this.currProduct.value.price_per_uom = this.productPrice + " per " + this.unitOfMeasure;
      const success = await this.saveCOGSDocument(this.currProduct);
      if (success) {
        this.altered = false;
        this.unitOfMeasure = "";
        this.productPrice = "";
        this.currProduct = { ...this.product };
        this.clearSearchQueries();
      }
    },

    async deleteProduct() {
      this.channel.push("cogs:delete", this.currProduct.id);
      this.deleteCOGSDocument();
      this.clearForm();
    },

    clearForm() {
      this.currProduct = { ...this.product };
      this.unitOfMeasure = "";
      this.productPrice = "";
      this.altered = false;
      this.searchQuery = "";
      this.productClicked = false;
    },
  },

  watch: {
    searchQuery: function () {
      this.foundProducts = this.queryCheck(this.searchQuery, this.cogsSearchProducts);
    },
  },

  mounted() {
    if (this.$route.params.loadProduct && this.$route.params.prod) {
      this.$nextTick(() => {
        const product = this.findIngredientByID(this.$route.params.prod);
        if (product) {
          this.loadProduct(product);
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.products-container {
  min-height: 90vh;

  .back-icon {
    font-size: 1.5rem;
    cursor: pointer;
    margin: 0.5rem 2rem;
    color: var(--action-colour);
  }

  .prod-section {
    display: flex;
    flex-direction: column;
    padding: 1rem;
  }

  .content-wrapper {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: flex-start;

    .cogs-prods {
      min-width: 30rem;
      max-width: 55%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      margin-bottom: 1rem;
      flex-grow: 1;

      .supplier-info {
        margin-top: 1rem;
        padding: 1.5rem 1rem;
        background-color: var(--primary-colour);
        box-shadow: var(--box-shadow);
        border-radius: 1rem;
        width: calc(100% - 2rem);
        h3 {
          margin: 0.25rem 0;
          display: flex;
          flex-direction: column;
          sub {
            color: var(--action-colour);
          }
        }
        .supplier-prods {
          margin-top: 1rem;
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
          place-items: center;
          gap: 0.5rem;

          .prod-from-supplier {
            width: 8rem;
            background-color: var(--secondary-colour);
            color: var(--text-colour);
            border: none;
            padding: 0.5rem;
            border-radius: 5px;
            font-size: 0.8rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
          }
        }
      }

      .form-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        background-color: var(--primary-colour);
        box-shadow: var(--box-shadow);
        border-radius: 1rem;

        button {
          margin: 0.5rem 0;
          background-color: var(--action-colour);
          box-shadow: var(--box-shadow);
          color: white;
          border: none;
          padding: 0.75rem;
          border-radius: 5px;
          cursor: pointer;
          &:active {
            transform: scale(0.98);
          }
        }

        .sub-btns {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: calc(100% - 3rem);
          margin: 0.5rem;
          padding: 0 1rem;

          button {
            margin-bottom: 1rem;
            background-color: var(--secondary-colour);
          }

          .btn-disabled {
            opacity: 0.4;
            cursor: not-allowed;
          }
        }

        h2 {
          padding: 1rem;
        }

        form {
          display: flex;
          min-width: 95%;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-evenly;
          flex-grow: 1;
          max-height: 80vh;
          overflow: auto;
          padding: 0 1rem;

          label {
            margin: 0.25rem;
            width: 100%;
            text-align: left;
          }

          input {
            width: 97%;
            padding: 0.5rem;
            margin: 0.25rem;
            box-shadow: var(--box-shadow);
            border-radius: 5px;
            border: none;
          }

          .gst {
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;
            width: 100%;

            .gst-radio {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              width: 30%;
              margin-left: 0.25rem;

              input {
                appearance: none;
                margin: 0 0.5rem;
                border-radius: 50%;
                transition: all 500ms ease-in-out;
                height: 1rem;
                width: 1rem;
                white-space: nowrap;
                border: 2px solid var(--tertiary-colour);

                &:checked {
                  background-color: var(--action-colour);
                  border: 5px solid var(--tertiary-colour);
                }
              }

              label {
                width: 20%;
                text-wrap: nowrap;
              }
            }
          }

          #price {
            width: 100%;
          }
        }
      }
    }

    .prod-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 1rem;
      min-width: 22rem;
      max-width: 50%;
      background-color: var(--primary-colour);
      box-shadow: var(--box-shadow);
      border-radius: 1rem;
      padding: 1rem;

      .search-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-width: 22rem;
        padding: 0.5rem;
        border-radius: 5px;

        h2 {
          margin: 0.5rem 0;
          padding: 0.5rem 0;
        }

        input {
          width: 100%;
          padding: 0.5rem;
          box-shadow: var(--box-shadow);
          border: 1px solid var(--secondary-colour);
          border-radius: 0.25rem;
          background-color: var(--opacity-background);
          color: var(--action-colour);
          margin: 0.5rem 0;
        }
        ul {
          max-height: 60vh;
          overflow: auto;
          margin: 0;
          padding: 0;

          li {
            display: flex;
            justify-content: space-between;
            list-style-type: none;
            margin: 0.5rem 0;
            border-bottom: 1px solid var(--tertiary-colour);

            a {
              text-decoration: none;
              text-wrap: wrap;
              width: 35rem;
              padding: 0 2rem 0 0;
              color: var(--text-colour);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .delete-indicator {
              font-size: 0.8rem;
              color: var(--text-colour);
            }

            .recipe-usage {
              font-size: 0.8rem;
              color: var(--warning-colour);

              .recipe-toggle {
                display: flex;
                flex-direction: column;
                align-items: center;
                cursor: pointer;

                .expanded {
                  transform: rotate(90deg);
                }
              }
              .hide {
                display: none;
              }

              small {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 0.5rem;
              }

              .recipe-list {
                display: flex;
                flex-direction: column;
                justify-content: center;
                p {
                  margin: 0.1rem 0;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .products-container {
    .prod-section {
      .content-wrapper {
        flex-direction: column;

        .cogs-prods {
          min-width: 90%;
          margin: 1rem auto;

          .gst {
            .gst-radio {
              label {
                width: 50%;
              }
            }
          }
        }

        .prod-list {
          margin: 0 auto;
          max-width: 90%;
          min-width: 90%;

          .search-container {
            min-width: 100%;
          }
        }
      }
    }
  }
}
</style>
